import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';
import { getFileName } from 'helpers/StringHelper';
import clsx from 'clsx';

import Box from '@material-ui/core/Box';
import Dropzone from 'react-dropzone';

const useStyles = makeStyles(({ theme, colors }) => ({
    dropzone: {
        border: `2px solid ${colors.primaryColor}`,
        borderRadius: '4px',
        padding: theme.spacing(4),
        cursor: 'pointer',
        color: colors.darkGrey
    }
}));

const DocumentDropzone = ({ fields, mediaType, multiple = false, maxFiles, maxSize, className, onDrop, children }) => {
    const classes = useStyles();
    const handleUploadSuccess = (uploadedMedia, document) => {
        document.description = getFileName(decodeURIComponent(document.mediaUrl));
    };

    const handleDrop = (acceptedFiles, fileRejections) => {
        onDrop(acceptedFiles, fileRejections, fields, mediaType.key, undefined, handleUploadSuccess);
    };

    return (
        <Dropzone
            multiple={multiple}
            maxFiles={maxFiles}
            accept={mediaType.accept.join(', ')}
            maxSize={maxSize}
            onDrop={handleDrop}
        >
            {({ getRootProps, getInputProps }) => (
                <Box {...getRootProps()} component="div" className={clsx(classes.dropzone, className)}>
                    <input {...getInputProps()} />
                    {children}
                </Box>
            )}
        </Dropzone>
    );
};

DocumentDropzone.propTypes = {
    fields: PropTypes.object.isRequired,
    mediaType: PropTypes.object.isRequired,
    className: PropTypes.string,
    multiple: PropTypes.bool,
    maxFiles: PropTypes.number,
    maxSize: PropTypes.number.isRequired,
    onDrop: PropTypes.func,
    children: PropTypes.node
};

export default DocumentDropzone;
